import React from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import styled from "styled-components";

// Styled components matching TargetGroupsContent styling
const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
`;

const ModalContent = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 900px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  position: relative;
  padding: 24px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
`;

const Header = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: #183967;
  margin: 0;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  padding-right: 36px;
`;

const ExportButton = styled.button`
  background: #1e3a5f;
  color: #fff;
  padding: 8px 16px;
  border-radius: 6px;
  flex-shrink: 0;
  cursor: pointer;
  &:hover { background: #162c48; }
`;

// Table styling similar to TargetGroupsContent
const TableWrapper = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 18px;
  margin: 16px 0 22px;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.06);
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  min-width: 680px;
  border-collapse: separate;
  border-spacing: 0;
  tbody tr:nth-child(even) td { background: #f7f9fb; }
  tbody tr:last-child td { border-bottom: none; }
`;

const Th = styled.th`
  background: #dce9fb;
  text-align: left;
  padding: 13px 16px;
  font-size: 13px;
  font-weight: 700;
  color: #1f3556;
  &:first-child { border-radius: 8px 0 0 8px; }
  &:last-child { border-radius: 0 8px 8px 0; }
`;

const Td = styled.td`
  padding: 13px 16px;
  font-size: 13px;
  color: #111827;
  border-bottom: 1px solid #d8dee6;
  line-height: 1.45;
`;

const AllScasModal = ({ isOpen, onClose, data }) => {
  if (!isOpen) return null;

  const exportPdf = () => {
    const doc = new jsPDF();
    const headers = ["S. No.", "Name", "State", "Address", "Contact"];
    const body = data.map((sca, index) => [
      index + 1,
      sca.name,
      sca.state,
      sca.address,
      sca.contact ?? "Not available",
    ]);
    doc.autoTable({
      head: [headers],
      body,
      theme: "striped",
      headStyles: { fillColor: [0, 91, 153], textColor: [255, 255, 255] },
      alternateRowStyles: { fillColor: [245, 245, 245] }
    });
    doc.save("All_SCAs.pdf");
  };

  return (
    <ModalOverlay>
      <ModalContent>
        <CloseButton onClick={onClose}>✕</CloseButton>
        <HeaderRow>
          <Header>All SCAs</Header>
          <ExportButton onClick={exportPdf}>Export as PDF</ExportButton>
        </HeaderRow>
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <Th>S. No.</Th>
                <Th>Name</Th>
                <Th>State</Th>
                <Th>Address</Th>
                <Th>Contact</Th>
              </tr>
            </thead>
            <tbody>
              {data.map((sca, index) => (
                <tr key={sca.id}>
                  <Td>{index + 1}</Td>
                  <Td>{sca.name}</Td>
                  <Td>{sca.state}</Td>
                  <Td>{sca.address}</Td>
                  <Td>{sca.contact ?? "Not available"}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>
      </ModalContent>
    </ModalOverlay>
  );
};

export default AllScasModal;
